<template>
  <v-list
    two-line
    subheader
  >
    <v-toolbar
      flat
    >
      <v-btn
        icon
        to="/training/List"
      >
        <v-icon>{{ mdiArrowLeft }}</v-icon>
      </v-btn>
      <v-toolbar-title>
        {{ $t('Training.Checkin.Record') }}
      </v-toolbar-title>
    </v-toolbar>

    <template v-if="!isLoading">
      <v-subheader v-if="activeCourses && activeCourses.length">
        {{ $t('Training.Checkin.ActiveClass') }}
      </v-subheader>
      <v-list-item
        v-for="course in activeCourses"
        :key="course.classSeqNum"
        :to="`/training/attendanceDetail/${course.classSeqNum}`"
      >
        <v-list-item-content>
          <v-list-item-title>{{ chPtObjData('nameZh', course) }}</v-list-item-title>
          <v-list-item-subtitle>
            {{ moment(course.startDate, dateFormat, dateLocale).format('YYYY-MM-DD') }}
            ~
            {{ moment(course.endDate, dateFormat, dateLocale).format('YYYY-MM-DD') }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <v-subheader v-if="inActiveCourses && inActiveCourses.length">
        {{ $t('Training.Checkin.InActiveClass') }}
      </v-subheader>
      <v-list-item
        v-for="course in inActiveCourses"
        :key="course.classSeqNum"
        :to="`/training/attendanceDetail/${course.classSeqNum}`"
      >
        <v-list-item-content>
          <v-list-item-title>{{ chPtObjData('nameZh', course) }}</v-list-item-title>
          <v-list-item-subtitle>
            {{ moment(course.startDate, dateFormat, dateLocale).format('YYYY-MM-DD') }}
            ~
            {{ moment(course.endDate, dateFormat, dateLocale).format('YYYY-MM-DD') }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <div class="pa-4 text-caption grey--text">
        * {{ $t('Training.Checkin.OnlyShowLimitRecord') }}
      </div>
    </template>
  </v-list>
</template>

<script>

import moment from 'moment'
import store from '@/store'
import courseAttendanceStore from '@/store/modules/training/courseAttendance'
import { courseAttendanceModule } from '@/store/moduleName'
import { mapGetters } from 'vuex'
import { mdiArrowLeft } from '@mdi/js'

if (!store.state[courseAttendanceModule]) store.registerModule(courseAttendanceModule, courseAttendanceStore)

export default {
  data: function () {
    return {
      mdiArrowLeft: mdiArrowLeft,
      isLoading: false,
      dateFormat: 'MMM D, YYYY HH:mm:ss A',
      dateLocale: 'en'
    }
  },
  computed: {
    ...mapGetters(courseAttendanceModule, [
      'activeCourses',
      'inActiveCourses'
    ])
  },
  created: function () {
    this.isLoading = true
    this.$store.dispatch(courseAttendanceModule + '/getClassList')
      .finally(() => {
        this.isLoading = false
      })
    // checkinApi.getClassList(resp => {
    //   if (resp.status === 0) {
    //     console.log(resp.datas)
    //     this.courses = resp.datas
    //   }
    //   this.isLoading = false
    // })
  },
  methods: {
    chPtObjData: function (fieldName, obj) {
      let tFieldName
      if (this.$i18n.locale === 'zh') {
        tFieldName = fieldName.replace('pt', 'zh')
        tFieldName = tFieldName.replace('Pt', 'Zh')
        if (!obj[tFieldName]) {
          tFieldName = fieldName.replace('zh', 'pt')
          tFieldName = tFieldName.replace('Zh', 'Pt')
        }
      } else {
        tFieldName = fieldName.replace('zh', 'pt')
        tFieldName = tFieldName.replace('Zh', 'Pt')
        if (!obj[tFieldName]) {
          tFieldName = fieldName.replace('pt', 'zh')
          tFieldName = tFieldName.replace('Pt', 'Zh')
        }
      }

      if (obj[tFieldName]) {
        return obj[tFieldName]
      } else {
        return ''
      }
    },
    moment: moment
  }
}
</script>
